import React from "react";
import './FameWall.css';
import './FameWallJapanese.css';

function FameWallJapanese() {
    return (
        <>
            <div className="champions-container">
                <h2>Fame Wall: Honoring Our Champions!</h2>
                <div class="border-gradient horizontal-underline only-top"></div>
                <div className="champions-wrap-jap">
                    <div className="champions-row row1">
                        <div className="champions-box box3">
                            <img src="/images/DashboardNew/Ribbon.png" alt="ribbon" className="ribbon-img" />
                            <h5 className="card-heading overall">Overall</h5>
                            <div className="badge-container middle">
                                <img src="/images/DashboardNew/Overall-badge.png" alt="overall-badge" className="overall-badge" />
                                <img src="/images/DashboardNew/Overall-badge.png" alt="overall-badge" className="overall-badge" />
                                <div className="internal-content overall">Internal <br />Certified <br /><span>42</span></div>
                                <div className="external-content overall">External <br />Certified <br /><span>138</span></div>
                            </div>
                        </div>
                    </div>
                    <div className="champions-row row2">
                        <div className="champions-box box4">
                            <img src="/images/DashboardNew/Ribbon.png" alt="ribbon" className="ribbon-img1" />
                            <h5 className="card-heading">N5</h5>
                            <div className="badge-container">
                                <img src="/images/DashboardNew/Badge.png" alt="badge" className=" badge-img" />
                                <div className="external-content">External <br />Certified <br /><span>19</span></div>
                            </div>
                        </div>
                        <div className="champions-box box4">
                            <img src="/images/DashboardNew/Ribbon.png" alt="ribbon" className="ribbon-img1" />
                            <h5 className="card-heading">N5</h5>
                            <div className="badge-container">
                                <img src="/images/DashboardNew/Badge.png" alt="badge" className=" badge-img" />
                                <div className="external-content">External <br />Certified <br /><span>19</span></div>
                            </div>
                        </div>
                        <div className="champions-box box4">
                            <img src="/images/DashboardNew/Ribbon.png" alt="ribbon" className="ribbon-img1" />
                            <h5 className="card-heading">N5</h5>
                            <div className="badge-container">
                                <img src="/images/DashboardNew/Badge.png" alt="badge" className=" badge-img" />
                                <div className="external-content">External <br />Certified <br /><span>19</span></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default FameWallJapanese;
